import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import React from "react";

const ColumnHeadings = ({ title, handleSort, field, sortConfig }) => {
  return (
    <Typography
      sx={{
        height: "100%",
        fontWeight: "bold",
        padding: "8px 12px",
        paddingLeft: title === "Date" ? "16px" : "12px",
        textAlign: "left",
        borderRight: "1px solid #ddd",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "6px",
        minWidth: 0,
        boxSizing: "border-box",
      }}
    >
      <Box
        component="span"
        sx={{
          flex: 1,
          minWidth: 0,
          lineHeight: 1.3,
          whiteSpace: "normal",
          wordBreak: "break-word",
        }}
      >
        {title}
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          flexShrink: 0,
          width: "22px",
        }}
      >
        <IconButton
          size="small"
          sx={{ p: 0, height: "14px", width: "22px" }}
          onClick={() => handleSort(field, "asc")}
        >
          <ExpandLess
            sx={{
              color:
                sortConfig.key === field && sortConfig.direction === "asc"
                  ? "blue"
                  : "black",
              fontSize: "18px",
            }}
          />
        </IconButton>
        <IconButton
          size="small"
          sx={{ p: 0, height: "14px", width: "22px" }}
          onClick={() => handleSort(field, "desc")}
        >
          <ExpandMore
            sx={{
              color:
                sortConfig.key === field && sortConfig.direction === "desc"
                  ? "blue"
                  : "black",
              fontSize: "18px",
            }}
          />
        </IconButton>
      </Box>
    </Typography>
  );
};

export default ColumnHeadings;
